/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
import imagesLoaded from 'imagesloaded';
import Cursor from "./modules/cursor";
import Magnetic from "./modules/magnetic";

// Wait for images to load
imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
  // Load stuff after all the images in the body load
  $('body').addClass('ready');
});

if (window.innerWidth > 960) {
  // Hide nav on scroll down
  const showAnim = gsap.from('.siteHeader', {
    yPercent: -100,
    paused: true,
    duration: 0.2
  }).progress(1);

  ScrollTrigger.create({
    // scroller: smoother,
    start: "top top",
    end: 99999,
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse()
    }
  });
}

// Don't load on mobile
function is_touch_enabled() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Mobile vs. Desktop controls
if (!is_touch_enabled()) {

  // Set up scroller on home page
  var onHomePage = document.querySelector('.template-index,.template-page-our-story');
  if (onHomePage) {
    let smoother = ScrollSmoother.create({
      smooth: 1,
      effects: true,
      // smoothTouch: 0.1,
      normalizeScroll: true
    });

    gsap.utils.toArray(".anchor").forEach(function (button, i) {
      button.addEventListener("click", (e) => {
        var id = e.target.getAttribute("href");
        smoother.scrollTo(id, true, "top top");
        e.preventDefault();
      });
    });

    let urlHash = window.location.href.split("#")[1];
    let scrollElem = document.querySelector("#" + urlHash);

    if (urlHash && scrollElem) {
      gsap.to(smoother, {
        scrollTop: smoother.offset(scrollElem, "top top"),
        duration: 0.5
      });
    }

    $('.stories__slideNav').on('click tap', function () {
      smoother.scrollTo('.stories--inner', true, "top top");
    });
  }

  // Set up cursor
  const cursor = new Cursor();
  $('[data-magnetic]').each(function () { new Magnetic(this); });

} else {
  $('body').addClass('touch');
}

// Site-Wide Functions
import { popupVideo } from './modules/popupVideo';
popupVideo();

import { mobileNav } from './modules/mobileNav';
mobileNav();

import { stickyNav } from './modules/stickyNav';
stickyNav();


// Home page specific functions
import { heroLoadAnimationSimpler } from './modules/heroLoadAnimation';
var heroLoadAnimationExists = document.querySelector('.homeHero');
if (heroLoadAnimationExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    heroLoadAnimationSimpler();
  });
}

import { brandVideosSlider } from './modules/brandVideosSlider';
var brandVideosSliderExists = document.querySelector('.brandVideos__slider');
if (brandVideosSliderExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    brandVideosSlider();
  });
}

import { storiesSlider } from './modules/storiesSlider';
var storiesSliderExists = document.querySelector('.stories__slider');
if (storiesSliderExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    storiesSlider();
  });
}

import { techSlider } from './modules/techSlider';
var techSliderExists = document.querySelector('.tech__slider');
if (techSliderExists) {
  techSlider();
}

import { articlesSlider } from './modules/articlesSlider';
var articlesSliderExists = document.querySelector('.articles__slider');
if (articlesSliderExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    articlesSlider();
  });
}

import { stickyGallery } from './modules/stickyGallery';
var stickyGalleryExists = document.querySelector('.scrollGallery');
if (stickyGalleryExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    setTimeout(() => {
      stickyGallery();
    }, 3000);
  });
}

// Build Table page specific functions
import { buildTableLoadAnimation } from './modules/buildTableLoadAnimation';
var buildTableLoadAnimationExists = document.querySelector('.buildHero__title');
if (buildTableLoadAnimationExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    buildTableLoadAnimation();
  });

  $('.tableOptions__color').on('click tap', function () {
    $('.tableOptions__color').removeClass('selected');
    $(this).addClass('selected');
  });

  $('.attachmentOptions__listItem').on('click tap', function () {
    $(this).toggleClass('selected');
  });
}

// Story page
import { storyScroll } from './modules/storyScroll';
var storyScrollExists = document.querySelector('.story__section');
if (storyScrollExists) {
  storyScroll();
}

// Support page
import { support } from './modules/support';
var supportExists = document.querySelector('.template-page-support');
if (supportExists) {
  support();
}

import { faqs } from './modules/toggle';
var faqsExist = document.querySelector('.faq');
if (faqsExist) {
  faqs();
}

// Product page
import { gallerySlider } from './modules/gallerySlider';
var gallerySliderExists = document.querySelector('.gallery__slider');
if (gallerySliderExists) {
  gallerySlider();
}

import { questionsSlider } from './modules/questionsSlider';
var questionsSliderExists = document.querySelector('.gallery__slider');
if (questionsSliderExists) {
  questionsSlider();
}

$('.product__variant').on('click tap', function () {
  $('.product__variant').removeClass('selected');
  $(this).addClass('selected');
});

// Support page
import { supportNavSlider } from './modules/supportNavSlider';
var supportNavSliderExists = document.querySelector('.supportNav__wrap');
if (supportNavSliderExists) {
  supportNavSlider();
}

// Form
import { contactForm } from './modules/contactForm';
var contactFormExists = document.querySelector('.form__label');
if (contactFormExists) {
  contactForm();
}

// Field Notes page
import { featuredNotesSlider } from './modules/featuredNotesSlider';
var featuredNotesSliderExists = document.querySelector('.featuredNotes__slider');
if (featuredNotesSliderExists) {
  featuredNotesSlider();

  $('.notesNav__filter').on('click tap', function () {
    $('.notesNav__filter').removeClass('selected');
    $(this).addClass('selected');
  });
}

// Animate On Scroll
import { animateOnScroll } from './modules/animateOnScroll.js';
imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
  animateOnScroll();
});

$('.tableFeatures__target').on('click tap', function () {
  if ($(this).hasClass("active")) {
    $('.tableFeatures__target').removeClass('active');
  } else {
    $('.tableFeatures__target').removeClass('active');
    $(this).toggleClass('active');
  }
});

// $('.description__readMore').on('click tap', function () {
//   $(this).hide()
//   $('.description__toggle').slideDown();
// });

// $('.description__readLess').on('click tap', function () {
//   $('.description__toggle').slideUp();
//   $('.description__readMore').show();
// });


// Refire stuff on window resize
var timeout = false, // holder for timeout id
  delay = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(function () {
    ScrollTrigger.refresh();

    if (heroLoadAnimationExists) {
      heroLoadAnimationSimpler();
    }

    if (stickyGalleryExists) {
      stickyGallery();
      smoother.effects('.scrollGallery__image');
    }
  }, delay);
});

// document.querySelectorAll('.attachment-form').forEach((attachment) => {
//   attachment.addEventListener('submit', async (e) => {
//     e.preventDefault();

//     // Submit via ajax
//     await fetch('/cart/add', {
//       method: "post",
//       body: new FormData(attachment)
//     });

//     // Update Cart
//     await updateCartDrawer();

//     // alert('firing');
//     // Open cart drawer
//     document.querySelector('.drawer').classList.add('active');

//   });
// });

// // Update cart
// async function updateCartDrawer() {
//   const res = await fetch('/?section_id=cart-drawer');
//   const text = await res.text();

//   const html = document.createElement('div');
//   html.innerHTML = text;
//   const newBox = html.querySelector('.cart-drawer').innerHTML;
//   document.querySelector('.cart-drawer').innerHTML = newBox;

//   console.log(html);
// }
